import { useContext } from "react";

import { ChromeContext } from "./context";

export const useChromeContext = () => {
  const context = useContext(ChromeContext);

  if (!context) {
    throw new Error("ChromeContext can only be used inside ChromeProvider");
  }

  return context;
};
